import { render, staticRenderFns } from "./VBorderTitle.vue?vue&type=template&id=2edd3121&"
import script from "./VBorderTitle.vue?vue&type=script&lang=js&"
export * from "./VBorderTitle.vue?vue&type=script&lang=js&"
import style0 from "./VBorderTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports